// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-slider__runway[data-v-5992e49a] {\n  height: 2px;\n  background-color: #303235;\n}\n.el-slider__bar[data-v-5992e49a] {\n  height: 1px;\n}\n", ""]);
// Exports
module.exports = exports;
